module.exports = __webpack_public_path__ + "static/media/dashboard2.687780fa.svg";